window.ModalVegas = {
	init: ($modal) => {
		let params = $modal.data();

		let option = {
			type:  $modal.data('modal') || 'bootstrap',
			target: $modal.attr('href') || $modal.data('target') || false,
			cloned_container: $modal.closest($modal.data('cloned-content')) || false,
		};

		option = $.extend(option, params);
		ModalVegas.scatter(option);
	},
	scatter: (option) => {
		if (option.target) {
			$.each(option, function (key, value) {
				let $element = $(option.target).find('[data-'+ key +']');

				if ($element.length) {
					if (key !== 'cloned') {
						let tagName = $element.prop('tagName').toLowerCase();

						if (tagName === 'input' || tagName === 'textarea' || tagName === 'select' || tagName === 'checkbox' || tagName === 'radio') {
							$element.val(value);
						} else {
							$element.html(value)
						}
					}
				}

				if (key === 'cloned' && option.cloned_container) {
					let classes = value.split(' '),
						$container = $(option.cloned_container);

					$.each(classes, function (k, v) {
						let content = $container.find('.' + v).html();

						$(option.target).find('.' + v).empty().html(content);
					});
				}
			});

			if (option.type === 'bootstrap') {
				ModalVegas.modalBootstrap(option);
			} else if(option.type === 'fancybox') {
				ModalVegas.modalFancybox(option);
			}
		}
	},
	modalBootstrap: (option) => {
		$(option.target).modal('show');
	},
	modalFancybox: (option) => {
		let defaults = [{
			src: option.target
		}];

		if (option.fancy) {
			defaults[0] = $.extend(option.fancy, defaults[0]);
		}

		$.fancybox.open(defaults);
	}
};
